export const showNotificationUtil = (
  message: string,
  SetLabelNotification: (value: string) => void,
  setNotification: (value: boolean) => void,
) => {
  SetLabelNotification(message);
  setNotification(true);

  setTimeout(() => {
    setNotification(false);
  }, 5000);
};
